module.exports = __webpack_public_path__ + "img/questionnaire.9311eb3e.svg";